import { render, staticRenderFns } from "./FlagIcons.vue?vue&type=template&id=3494b503&scoped=true"
import script from "./FlagIcons.vue?vue&type=script&lang=js"
export * from "./FlagIcons.vue?vue&type=script&lang=js"
import style0 from "./FlagIcons.vue?vue&type=style&index=0&id=3494b503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494b503",
  null
  
)

export default component.exports